import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterOutlet} from '@angular/router';
import {AppInitService} from './common/service/app-init.service';
import {PatientHeaderComponent} from './common/component/patient-header/patient-header.component';
import {PatientFooterComponent} from './common/component/patient-footer/patient-footer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, PatientHeaderComponent, PatientFooterComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(public appInitService: AppInitService) {
  }
}
